import { Component, ChangeDetectionStrategy } from '@angular/core';

import { GridPanelComponent } from '../grid-panel/grid-panel.component';

@Component({
    selector: 'aa-grid-simple-panel',
    templateUrl: './grid-simple-panel.component.html',
    styleUrls: [
        '../grid-container.constants.scss'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GridSimplePanelComponent extends GridPanelComponent
{
}
